import { t } from "i18next";
import { ComputeFieldComponent } from "../computeFields";
import { Audiovisual } from "../types";
import { SeparatedList } from "./shared/utils";
import { ComponentProps } from "react";

const AudiovisualAuthorNameCF: ComputeFieldComponent<
  Pick<
    Audiovisual,
    "audiovisuelDescriptionAuteurAnonyme" | "audiovisuelDescriptionAuteur"
  >
> = ({ input, language: forceLang }) => {
  if (input.audiovisuelDescriptionAuteurAnonyme) {
    return <>{t("computeField.artisteAnonymeAbbrege", { lng: forceLang })}</>;
  }
  if (input.audiovisuelDescriptionAuteur) {
    return <>{input.audiovisuelDescriptionAuteur}</>;
  }
  return null;
};

const AudiovisualTitleCF: ComputeFieldComponent<
  Pick<
    Audiovisual,
    | "audiovisuelDescriptionTitreInconnu"
    | "audiovisuelDescriptionTitreSansTitre"
    | "audiovisuelDescriptionTitre"
  >
> = ({ input, language: forceLang }) => {
  if (input.audiovisuelDescriptionTitreInconnu) {
    return <>{t("computeField.titreInconnuAbbrege", { lng: forceLang })}</>;
  }
  if (input.audiovisuelDescriptionTitreSansTitre) {
    return <i>{t("computeField.sansTitreAbbrege", { lng: forceLang })}</i>;
  }
  if (input.audiovisuelDescriptionTitre) {
    return <i>{input.audiovisuelDescriptionTitre}</i>;
  }
  return null;
};

const AudiovisualTechniqueCF: ComputeFieldComponent<
  Pick<
    Audiovisual,
    | "audiovisuelDescriptionType"
    | "audiovisuelDescriptionTechniqueCouleur"
    | "audiovisuelDescriptionTechniqueDuree"
    | "audiovisuelDescriptionTechniqueVersionLangue"
  >
> = ({ input, language, ...props }) => (
  <SeparatedList
    language={language}
    input={[
      <SeparatedList
        {...props}
        language={language}
        input={[
          input.audiovisuelDescriptionType,
          input.audiovisuelDescriptionTechniqueCouleur &&
            t("computeField.couleurAbbrege", { lng: language }),
        ]}
      />,
      input.audiovisuelDescriptionTechniqueDuree &&
        `${input.audiovisuelDescriptionTechniqueDuree} ${t("computeField.minutesAbbrege", { lng: language })}`,
      input.audiovisuelDescriptionTechniqueVersionLangue,
    ]}
  />
);

export const AudiovisualSummaryCF: ComputeFieldComponent<
  ComponentProps<typeof AudiovisualAuthorNameCF>["input"] &
    ComponentProps<typeof AudiovisualTechniqueCF>["input"] &
    ComponentProps<typeof AudiovisualTitleCF>["input"] &
    Pick<
      Audiovisual,
      | "audiovisuelDescriptionEmission"
      | "audiovisuelDescriptionPays"
      | "audiovisuelDescriptionDateDeCreationInconnue"
      | "audiovisuelDescriptionDateDeCreation"
    >
> = ({ input, language }) => {
  return (
    <SeparatedList
      endWithPeriod
      commaSeparated={false}
      language={language}
      input={[
        <SeparatedList
          language={language}
          endWithPeriod
          input={[
            <AudiovisualAuthorNameCF
              key="author"
              input={input}
              language={language}
            />,
            <AudiovisualTitleCF
              key="title"
              input={input}
              language={language}
            />,
            input.audiovisuelDescriptionEmission,
            input.audiovisuelDescriptionPays,
            input.audiovisuelDescriptionDateDeCreationInconnue
              ? t("computeField.dateInconnueAbbrege", { lng: language })
              : input.audiovisuelDescriptionDateDeCreation,
          ]}
        />,
        <AudiovisualTechniqueCF
          key="technique"
          input={input}
          language={language}
        />,
      ]}
    />
  );
};
